import React, {Fragment} from 'react';
import Navbar from '../../components/Navbar'
import PageTitle from '../../components/pagetitle'
import {useParams} from 'react-router-dom'
import Scrollbar from '../../components/scrollbar'
import {past_events, future_events} from '../../api/event'
import EventTabs from './alltab'
import EventSidebar from './sidebar'
import Logo from '../../images/logo.png'
import Footer from '../../components/footer';
import Gallery from '../../components/Gallery/Gallery';

const EventSinglePage =(props) => {

    const {id} = useParams()

    let eventDetails = past_events.find(item => item.id === id);
    if (!eventDetails) {
        eventDetails = future_events.find(item => item.id === id);
    }

    return(
        <Fragment>
            <Navbar Logo={Logo}/>
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={eventDetails.eTitle}/> 
            <div className="wpo-event-details-area section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col col-lg-8">
                            <div className="wpo-event-item">
                                <div className="wpo-event-img">
                                    <img src={eventDetails.eImg} alt=""/>
                                </div>
                                <div className="wpo-event-details-text">
                                    <h2>{eventDetails.eTitle}</h2>
                                    <p>{eventDetails.desc}</p>
                                </div>
                                <EventTabs event={eventDetails}/>
                                <Gallery event={eventDetails}/>
                            </div>
                        </div>
                        {/* <EventSidebar/> */}
                    </div>
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};
export default EventSinglePage;
